import { Button } from "@/components/ui/button";
import heroPoster from "@/assets/hero-poster.webp";

const BOOKING_URL = "https://booking.wellnessacademyusa.com/booking-page-wellness-academy";

const HeroSection = () => {
  return (
    <>
      <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0 w-full h-full overflow-hidden pointer-events-none">
          <video
            className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[177.78vh] min-w-full min-h-full aspect-video object-cover"
            src="/video/hero-bg.mp4"
            poster={heroPoster}
            autoPlay
            muted
            loop
            playsInline
            preload="auto"
            // @ts-expect-error fetchpriority is valid HTML
            fetchpriority="high"
            aria-hidden="true"
          />
        </div>
        <div className="absolute inset-0 bg-hero-overlay/45" />

        <div className="relative z-10 max-w-4xl mx-auto px-6 sm:px-12 md:px-16 py-32 flex flex-col items-center text-center">
          <h1 className="hero-h1 font-serif font-light text-hero-text leading-[1.1] tracking-wide mb-5 md:mb-8 lg:whitespace-nowrap">
            The Science of <span className="text-nav-cta">Living Well</span>
          </h1>
          <p className="font-sans text-sm sm:text-base md:text-xl text-hero-text-muted leading-relaxed max-w-2xl mb-8 md:mb-12 font-light">
            Personalized lifestyle programs designed to restore health, extend healthspan, and protect vitality for life.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4 mb-8 md:mb-12">
            <Button variant="hero" size="lg" asChild className="px-8 sm:px-10 py-5 sm:py-6 text-xs">
              <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer">
                Book a Discovery Call
              </a>
            </Button>
            <Button variant="heroGhost" size="lg" asChild className="px-8 sm:px-10 py-5 sm:py-6 text-xs">
              <a href="#programs">Explore Our Method</a>
            </Button>
          </div>
          <p className="font-sans text-[10px] sm:text-xs text-hero-trust tracking-widest uppercase">
            Board-Certified Health Coaching · Remote and In-Person · Luxury Lifestyle Retreats
          </p>
        </div>
      </section>
    </>
  );
};

export default HeroSection;
